// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ODEk","toggleWrap":"styles_toggleWrap__35cRa","content":"styles_content__1eWFn","selectAreaCode":"styles_selectAreaCode__2quYS"};